export var createMargins = function (_a) {
    var top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return ({
        marginTop: top + "px",
        marginBottom: bottom + "px",
        marginLeft: left + "px",
        marginRight: right + "px",
    });
};
